import SubCommentList from './SubCommentList'

export default SubCommentList
